import type { ExpeditionCoordinate } from '@api/ringil-api.v2';

export type ExpeditionTarget = { side: 'customer'; expeditionId: string } | { side: 'carrier'; customerId: string; applicationId: string };

/**
 * One expedition has two detail pages: the customer one (`/expedition/{id}`, also used by customs and other
 * partner companies) and the carrier one (`/carrier/shipment/{customerId}-{applicationId}`). A carrier cannot
 * open the customer page, and a company-level role cannot tell which side the user is on for this particular
 * expedition (a forwarder can be both), so the backend decides per recipient via `coords.isCarrier`.
 *
 * Without coordinates — or with incomplete carrier ones — we keep the customer page, the historical behaviour.
 */
export const resolveExpeditionTarget = (expeditionId: string, coords?: ExpeditionCoordinate): ExpeditionTarget => {
  if (coords?.isCarrier === true && coords.customerId && coords.applicationId) {
    return { side: 'carrier', customerId: coords.customerId, applicationId: coords.applicationId };
  }
  return { side: 'customer', expeditionId: coords?.expeditionId ?? expeditionId };
};
